import type { Kayttaja } from '../types'

/**
 * Palauttaa käyttäjän näytettävän nimen.
 *
 * Käyttäjä on saattanut luoda tilin sähköpostilla ja PIN-koodilla
 * onnistuneesti, mutta epäonnistunut ID-proofingissa (NFC, MRZ, selfie) —
 * jolloin järjestelmä EI tiedä hänen nimeä eikä syntymäaikaa. Pelkkä
 * sähköposti tunnetaan. Tämä on suuri osa tukipyynnöistä.
 *
 * Sopimus:
 * - Jos etunimi & sukunimi ovat asetettu → "Etunimi Sukunimi"
 * - Muutoin → sähköpostiosoite (signaali: tunnistautumaton käyttäjä)
 *
 * HenkilollisyysBadge kertoo erikseen statuksen ("Henkilöllisyyttä ei
 * todennettu"), joten nimi-slot itsessään ei tarvitse erillistä "ei
 * tunnistautunut" -tagia — sähköpostin näkyminen nimi-slotissa on jo
 * itsessään yksiselitteinen visuaalinen signaali ammattilaiselle.
 */
export function naytaNimi(kayttaja: Kayttaja): string {
  if (kayttaja.etunimi.trim() && kayttaja.sukunimi.trim()) {
    return `${kayttaja.etunimi} ${kayttaja.sukunimi}`
  }
  return kayttaja.sahkoposti
}

/** True jos käyttäjällä ei ole nimeä (ID-proofing kesken). */
export function onTunnistautumaton(kayttaja: Kayttaja): boolean {
  return !kayttaja.etunimi.trim() || !kayttaja.sukunimi.trim()
}

/**
 * Henkilöllisyyden vahvistuksen statusteksti suomeksi.
 * Näytetään UID:n alapuolella harmaalla — kertoo virkailijalle yhdellä
 * silmäyksellä, onko käyttäjä jo todentanut itsensä uudella sovelluksella
 * (20.5.2026 työpaja, B3). Käytetään myös käyttäjäkortin sivupalkilla.
 */
export function vahvistusStatus(kayttaja: Kayttaja): string {
  return kayttaja.henkilollisyysTodennettu
    ? "vahvistus.vahvistettu"
    : "vahvistus.eiVahvistettu";
}
